export default __webpack_public_path__ + "static/media/Supreme_Grandmaster_Mentor.b67be768.png";